import { render, staticRenderFns } from "./studentDrawer.vue?vue&type=template&id=4027999c&"
import script from "./studentDrawer.vue?vue&type=script&lang=js&"
export * from "./studentDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports